<div>
  @if (isFacebookInAppBrowser() && isAndroid() && !hideChromeBanner && braintreeEnabled && braintreeOneTimeCheckout &&
  !isSubscription && accountForm && !accountForm.valid) {
  <div class="facebook-chrome-link-container">
    <button class="close-button" (click)="hideChromeBanner = true">&times;</button>
    <a href="intent://{{getHost()}}{{getPath()}}{{getSearch()}}#Intent;scheme=https;package=com.android.chrome;end"
      class="facebook-chrome-link">
      Open in Chrome for Faster Checkout
    </a>
  </div>
  }
  <brand-header></brand-header>

  @if (noticeOn) {
  <div class="topCartDelay">
    <div>
      <div col-12 [innerHTML]="noticeText"></div>
    </div>
  </div>
  }

  <section id="orderForm-validation-error-box" class="errors">
    @if (!couponValidation) {
    <div class="errors__row">
      <div col-12 class="errors__col">
        <ul class="errors__list">
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"
              [innerHTML]="getLabelCheckout('couponinvalid') ? getLabelCheckout('couponinvalid') : 'Sorry, the coupon code you have entered is invalid. Please check the code and try again.'">Sorry,
              the <strong>coupon code</strong> you have entered is invalid. Please check
              the code and try again.</span>
          </li>
        </ul>
      </div>
    </div>
    }
    <!--
    <div class="debug-info">
      <h4>Debug Information:</h4>
      <ul>
        <li>submittedAccountForm: {{submittedAccountForm}}</li>
        <li>submittedPaymentForm: {{submittedPaymentForm}}</li>
        <li>accountForm?.invalid: {{accountForm?.invalid}}</li>
        <li>accountForm?.valid: {{accountForm?.valid}}</li>
        <li>accountForm?.controls?.state?.value: {{accountForm?.controls?.state?.value}}</li>
        <li>braintreeEnabled: {{braintreeEnabled}}</li>
        <li>braintreeInstance: {{braintreeInstance}}</li>
        <li>braintreeDropInEnabled: {{braintreeDropInEnabled}}</li>
        <li>braintreeDropinValid: {{braintreeDropinValid}}</li>
        <li>braintreeHostedFieldsValid: {{braintreeHostedFieldsValid}}</li>
        <li>braintreePayPalTokenizedPayment: {{braintreePayPalTokenizedPayment}}</li>
        <li>isSelectedCB2: {{isSelectedCB2}}</li>
        <li>diffAddress?.invalid: {{diffAddress?.invalid}}</li>
        <li>paymentForm?.invalid: {{paymentForm?.invalid}}</li>
        <li>rejectOrder: {{rejectOrder}}</li>
      </ul>
    </div>
    -->
    @if (
    (submittedAccountForm || submittedPaymentForm) &&
    (
    (accountForm && accountForm.invalid) ||
    (accountForm && accountForm.valid && accountForm.controls && accountForm.controls['state'] &&
    accountForm.controls['state'].value === '' && statesList && statesList.length > 0) ||
    (braintreeEnabled && braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) ||
    (!braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment ) )) ||
    (!isSelectedCB2 && diffAddress && diffAddress.invalid) ||
    (paymentForm && paymentForm.invalid) ||
    rejectOrder
    )
    ) {
    <div class="errors__row">
      <!-- Currently, we have a temporary fix for red border showing at the top even we have a successfull transaction. Need to refactor the ngIf above to figure out which conditions needs to be modified. -->
      <div col-12 class="errors__col"
        [ngClass]="{ 'errors__col--noBorder': (!accountForm.invalid && !paymentForm.invalid && !diffAddress?.invalid && !rejectOrder) }">
        @if (!rejectOrder && accountForm.invalid) {
        <p class="errors__info"
          [innerHTML]="getLabelCheckout('pleasecheck') ? getLabelCheckout('pleasecheck') : 'Please check the following errors'">
          Please сheck the following errors</p>
        }
        <ul class="errors__list">
          <!-- REJECT ORDER -->
          @if (rejectOrder) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{rejectOrderMessage.header}}</strong></span>
          </li>
          <li class="errors__item">
            <span class="errors__text">{{rejectOrderMessage.body}}</span>
          </li>
          }
          <!-- ACCOUNT FORM -->
          @if (accountForm.controls['firstName'].invalid && accountForm.controls['firstName'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('firstName') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (accountForm.controls['firstName'].invalid && accountForm.controls['firstName'].errors.pattern) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('firstName')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          }
          @if (accountForm.controls['lastName'].invalid && accountForm.controls['lastName'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('lastName') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (accountForm.controls['lastName'].invalid && accountForm.controls['lastName'].errors.pattern) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('lastName')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          }
          @if (accountForm.controls['phone'].invalid && accountForm.controls['phone'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('phone') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (accountForm.controls['phone'].invalid && accountForm.controls['phone'].errors.pattern) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('phone')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          }
          @if (accountForm.controls['email'].invalid && accountForm.controls['email'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('email') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (
          accountForm.controls['email'].invalid &&
          (
          accountForm.controls['email'].errors.email ||
          accountForm.controls['email'].errors.invalidValidEmail
          ) &&
          accountForm.controls['email'].value &&
          accountForm.controls['email'].value.length > 0
          ) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>Email</strong> {{ getLabelCheckout('address is invalid')}}.</span>
          </li>
          }
          @if (accountForm.controls['confirmEmail'].invalid && accountForm.controls['confirmEmail'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('confirmEmail') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (
          accountForm.controls['confirmEmail'].invalid &&
          (
          accountForm.controls['confirmEmail'].errors.email ||
          accountForm.controls['confirmEmail'].errors.invalidValidEmail
          ) &&
          accountForm.controls['confirmEmail'].value &&
          accountForm.controls['confirmEmail'].value.length > 0
          ) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('confirmEmail')}}</strong> {{
              getLabelCheckout('address is invalid')}}.</span>
          </li>
          }
          @if (
          accountForm.controls['confirmEmail'].invalid &&
          (
          accountForm.controls['email'].invalid &&
          accountForm.controls['email'].errors.invalidConfirmEmails ||
          accountForm.controls['confirmEmail'].errors.invalidConfirmEmails
          ) &&
          accountForm.controls['email'].value &&
          accountForm.controls['email'].value.length > 0 &&
          accountForm.controls['confirmEmail'].value &&
          accountForm.controls['confirmEmail'].value.length > 0
          ) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('confirmEmail')}}</strong> does not match
              Email.</span>
          </li>
          }
          @if (accountForm.controls['street'].invalid && accountForm.controls['street'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('addressTC') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (accountForm.controls['street'].invalid && accountForm.controls['street'].errors.pattern) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('addressTC')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          }
          @if (accountForm.controls['city'].invalid && accountForm.controls['city'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('city') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (accountForm.controls['city'].invalid && accountForm.controls['city'].errors.pattern) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('city')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          }
          @if (accountForm.controls['zipPostalCode'].invalid && accountForm.controls['zipPostalCode'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('zipTC') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (accountForm.controls['zipPostalCode'].invalid && accountForm.controls['zipPostalCode'].errors.pattern) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('zipTC')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          }
          @if (accountForm.controls['country'].invalid && accountForm.controls['country'].errors.required) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('country') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          @if (accountForm.controls['state'].value === '' && statesList && statesList.length > 0) {
          <li class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('state') }} </strong>
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span>
          </li>
          }
          <!-- SHIPPING ADDRESS -->
          @if (!isPayPalBillingAgreementApproved && buttonList[0].isPlaceOrder) {
          <div>
            @if (diffAddress?.controls?.['firstNameShipping']?.invalid &&
            diffAddress?.controls?.['firstNameShipping']?.errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('firstName')}}</strong> <span>
                  Is a required Shipping information field</span>.</span>
            </li>
            }
            @if (diffAddress?.controls?.['firstNameShipping']?.invalid &&
            diffAddress?.controls?.['firstNameShipping']?.errors?.pattern) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('firstName')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            }
            @if (diffAddress?.controls?.['lastNameShipping']?.invalid &&
            diffAddress?.controls?.['lastNameShipping']?.errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('lastName')}}</strong> <span>
                  Is a required Shipping information field</span>.</span>
            </li>
            }
            @if (diffAddress?.controls?.['lastNameShipping']?.invalid &&
            diffAddress?.controls?.['lastNameShipping']?.errors?.pattern) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('lastName')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipAddress']?.invalid &&
            diffAddress?.controls?.['shipAddress']?.errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('addressTC')}}</strong> <span>
                  Is a required Shipping information field</span>.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipAddress']?.invalid &&
            diffAddress?.controls?.['shipAddress']?.errors?.pattern) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('addressTC')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipCity']?.invalid && diffAddress?.controls?.['shipCity']?.errors?.required)
            {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('city')}}</strong> <span>
                  Is a required Shipping information field</span>.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipCity']?.invalid && diffAddress?.controls?.['shipCity']?.errors?.pattern) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('city')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipPostal']?.invalid &&
            diffAddress?.controls?.['shipPostal']?.errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('zipTC')}}</strong> <span>
                  Is a required Shipping information field</span>.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipPostal']?.invalid &&
            diffAddress?.controls?.['shipPostal']?.errors?.pattern) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('zipTC')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipCountry']?.invalid &&
            diffAddress?.controls?.['shipCountry']?.errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('country')}}</strong> <span>
                  Is a required Shipping information field</span>.</span>
            </li>
            }
            @if (diffAddress?.controls?.['shipState']?.value === '' && differentAddressStatesList &&
            differentAddressStatesList.length > 0) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('state')}}</strong> <span>
                  Is a required Shipping information field</span>.</span>
            </li>
            }
          </div>
          }
          <!-- PAYMENT FORM -->
          <!-- This error is only for braintree hosted fields on our checkout pages so we have !enableCyberSource as one of the conditionals which implies that the checkout page fields are Braintree -->
          @if (braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!enableCyberSource &&
          !braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment))) {
          <div>
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"
                [innerHTML]="getLabelCheckout('pleaseselect') ? getLabelCheckout('pleaseselect') : 'Please select a payment method'">Please
                select a payment method.</span>
            </li>
          </div>
          }
          <!-- These errors are for credit card fields using Cybersource and non for Braintree credit card fields so we have enableCyberSource && !braintreePayPalTokenizedPayment as the conditionals -->
          @if ((!braintreeInstance && !isPayPalBillingAgreementApproved && buttonList[0].isPlaceOrder) ||
          (enableCyberSource && !braintreePayPalTokenizedPayment)) {
          <div>
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['nameOnCard'] &&
            paymentForm.invalid && paymentForm.controls['nameOnCard'].errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('nameCard') }}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>
            }
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['nameOnCard'] &&
            paymentForm.invalid && paymentForm.controls['nameOnCard'].errors?.pattern) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('nameCard')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            }
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['number'] && paymentForm.invalid
            && paymentForm.controls['number'].errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('cardNumber')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>
            }
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['number'] && paymentForm.invalid
            && paymentForm.controls['number'].errors && (paymentForm.controls['number'].errors.invalidTypeNumber ||
            paymentForm.controls['number'].errors.invalidNumber)) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">Invalid <strong>credit card number</strong>.</span>
            </li>
            }
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['expCard'] &&
            paymentForm.controls['expCard'].errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('monthDateTC')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>
            }
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['expCard'] &&
            paymentForm.controls['expCard'].errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('yearDateTC')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>
            }
            @if (
            submittedPaymentForm && paymentForm?.controls &&
            paymentForm.controls['expmonth'] && paymentForm.controls['expyear'] &&
            paymentForm.invalid &&
            (
            paymentForm.controls['expmonth'].errors?.cardExpired ||
            paymentForm.controls['expyear'].errors?.cardExpired
            )
            ) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('expirationDate')}}</strong> is invalid. Card has
                expired.</span>
            </li>
            }
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['code'] && paymentForm.invalid &&
            paymentForm.controls['code'].errors?.required) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('cvvTC')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>
            }
            @if (submittedPaymentForm && paymentForm?.controls && paymentForm.controls['code'] && paymentForm.invalid &&
            paymentForm.controls['code'].errors && (paymentForm.controls['code'].errors.minlength ||
            paymentForm.controls['code'].errors.maxlength)) {
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('cvvTC')}}</strong> is invalid.</span>
            </li>
            }
          </div>
          }
        </ul>
      </div>
    </div>
    }
  </section>

  <section class="form__grid" [ngClass]="{'submitted__errors': (submittedAccountForm &&
  (
    (accountForm && accountForm.invalid) ||
    (accountForm && accountForm.valid && accountForm.controls && accountForm.controls['state'] && accountForm.controls['state'].value === '' && statesList && statesList.length > 0) ||
    (isSelectedCB2 && accountForm && accountForm.invalid) ||
    (braintreeEnabled && braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment ) )) ||

    (isSelectedCB2 && accountForm && accountForm.valid && accountForm.controls && accountForm.controls['shipState'] && accountForm.controls['shipState'].value === '' && differentAddressStatesList && differentAddressStatesList.length > 0)  ||
    (!isSelectedCB2 && diffAddress && diffAddress.invalid) ||
    rejectOrder
  ) ||
  submittedPaymentForm &&
  (
    (paymentForm && paymentForm.invalid) ||
    rejectOrder
  ))}">

    @if (braintreeCountrySelector) {
    <div class="form__row tabs tabs__col" style="display:contents;cursor:pointer;font-size:small;float:right;"
      class="tooltip-country">
      <div class="tooltip-country-col">🌐
        <span class="tooltiptext-country">
          <p class="tooltipinnerglobe">🌐</p>
          <select style="min-width: 140px;" (change)="changeBraintreeSettings($event)">
            @for (item of braintreeEUCountries; track $index; let i = $index; let isLast = $last) {
            @if (item == braintreeDefaultCountry) {
            <option selected>{{item}}</option>
            }
            @if (item != braintreeDefaultCountry) {
            <option>{{item}}</option>
            }
            }
          </select>
          <select style="min-width: 140px; margin-right:15px;" (change)="changeBraintreeCurrencySettings($event)">
            @for (item of braintreeCurrencies; track $index; let i = $index; let isLast = $last) {
            @if (item == currency) {
            <option selected>{{item}}</option>
            }
            @if (item != currency) {
            <option>{{item}}</option>
            }
            }
          </select>
        </span>
      </div>
    </div>
    }
    <div class="order_content_wrapper form__row">
      <!-- ORDER BUTTONS -->
      <article [hidden]="buttonList[0].isPlaceOrder" class="order_buttons_wrapper">
        <div class="padding0" col-12 [attr.col-md-4]="isSubscription ? true : null"
          [attr.col-md-6]="isSubscription ? null : true">
          <div id="addressBookWidgetDiv" class="amazon-widget"></div>
        </div>
        <div class="padding0" col-12 [attr.col-md-4]="isSubscription ? true : null"
          [attr.col-md-6]="isSubscription ? null : true">
          <div id="walletWidgetDiv" class="amazon-widget"></div>
        </div>
        <div class="padding0" col-12 [attr.col-md-4]="isSubscription ? true : null" [hidden]="!isSubscription">
          <div id="consentWidgetDiv" class="amazon-widget"></div>
        </div>
      </article>
      <article [hidden]="buttonList[0].isPlaceOrder" class="order_buttons_wrapper form__row">
        <div col-12 [attr.col-md-4]="isSubscription ? true : null" [attr.col-md-6]="isSubscription ? null : true">
          <div onclick="window.amazon.Login.logout();location.reload(); return false;"
            style="color:lightgray; cursor:pointer; text-decoration: underline; float: left; padding-left: 10px; font-size: x-small;">
            Amazon logout</div>
        </div>
        <div col-12 [attr.col-md-4]="isSubscription ? true : null" [attr.col-md-6]="isSubscription ? null : true">
          <div></div>
        </div>
        <div col-12 [attr.col-md-4]="isSubscription ? true : null" [hidden]="!isSubscription">
          <div></div>
        </div>
      </article>
      <article class="order_buttons_wrapper">
        <div col-12 col-lg-6 pull-lg-6 class="form_col form_col_v2">
          @if (showPaypal) {
          <div class="buttons_wrapper buttonsWrapperV2" [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
            <div [hidden]="!showPayPalPayButton">
              @if (!isPayPalBillingAgreementApproved && (!isSubscription || !isPurchaseAvailable)) {
              <button name="PayPal" id="order-form-paypal-button" class="paypal_button buttonsWrapperV2__paypalButton"
                alt="PayPal" type="submit" (click)="checkoutPayPalWithDifferentAddress(accountForm, diffAddress)"><img
                  src="{{ iconPaypal }}" alt="PayPal" loading="eager" fetchpriority="high" decoding="sync" /></button>
              }
              @if (!isPayPalBillingAgreementApproved && (!isSubscription || !isPurchaseAvailable)) {
              <p class="buttonsWrapperV2__standardOrderText">- Or -</p>
              }
            </div>
            <div [hidden]="isPayPalBillingAgreementApproved || !showAmazonButton" id="AmazonPayButton"
              class="amazonpay_button buttonsWrapperV2__amazonButton"></div>
            <div [hidden]="showPayPalPayButton" class="paypalBtnContainer">
              <img class="paypalBtnPlaceholder" src="/assets/img/paypalBtnPlaceholder2.png" alt="PayPal" />
              <div [hidden]="braintreeHidePayPalButton || isBraintreeLoading || !braintreeEnabled" id="paypal-button"
                class="paypal_buttonWrapper buttonsWrapperV2__paypalButtonBT"></div>
              <p class="buttonsWrapperV2__standardOrderTextBT">- Or -</p>
            </div>
          </div>
          }
        </div>
      </article>

      <!--ORDER DETAILS-->
      @if (showProductBox) {
      <article class="order_details_wrapper form__row  order_detail_row">
        <div col-12 class="order_detail_col">
          <div class="order_detail_table">
            <div class="order_detail_table_col">
              <div class="order_detail_title">
                <span class="form__title"
                  [innerHTML]="getLabelCheckout('orderdetail') ? getLabelCheckout('orderdetail') : 'Order Detail'">Order
                  Detail</span>
                <div class="form__title_description mt-5">
                  <span [innerHTML]="getLabelCheckout('item') ? getLabelCheckout('item') : 'Item'">Item</span>
                  <span [innerHTML]="getLabelCheckout('price') ? getLabelCheckout('price') : 'Price'">Price</span>
                </div>
              </div>
            </div>
            <hr class="order_detail_hr">
            <div class="order_detail_table_col mt-10">
              <div class="order_detail_table_col_content">
                @if (currentFunnel.subscriptionFrequency !== 'Monthly') {
                <img class="product_img" src={{newImage}} alt="Product Image" loading="eager" fetchpriority="high"
                  decoding="sync">
                }
                @if (currentFunnel.subscriptionFrequency === 'Monthly') {
                <img class="product_img" src={{currentFunnel.product?.image?.[1]?.imageUrl}} alt="Product Image"
                  loading="eager" fetchpriority="high" decoding="sync">
                }
                <div class="form__title_wrap">
                  <div class="form__title_description">
                    <span class="order_detail_bold"></span>
                    <!-- Consolidated Generic -->
                    @if (totalPrice <= 0) { <span class="order_detail_price">
                      {{ ( (1 * (currentFunnel.offerPrice || 0)) + ((currentFunnel.isFreeFirstShipping && selectedDeliveryDay
                      == 'Free' ) ? 0 : (1 * shippingCost)) + (1 * couponDiscount) ) | dynamicCurrency:currency }}
                      </span>
                      }
                      @if (showProductBox && coupon.discountType !== 'Free Shipping' && totalPrice > 0) {
                      <span class="order_detail_price">
                        {{ (currentFunnel.offerPrice || 0) | dynamicCurrency:currency }}
                      </span>
                      }
                  </div>
                  <div class="form__title_description mt-5">
                    <div class="product_description pl-7">
                      <span>Quantity: {{currentFunnel.product?.description}}</span>
                    </div>
                    @if (currentFunnel.subscriptionFrequency === 'Monthly') {
                    <span class="order_detail_price"
                      [innerHTML]="getLabelCheckout('subscription') ? getLabelCheckout('subscription') : 'Subscription'">Subscription</span>
                    }
                    @if (currentFunnel.subscriptionFrequency !== 'Monthly') {
                    <span class="order_detail_price"
                      [innerHTML]="getLabelCheckout('onetimepurchase') ? getLabelCheckout('onetimepurchase') : 'One Time Purchase'">One
                      Time Purchase</span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
      }

      <!-- CUSTOMER INFORMATION -->
      <article class="customer_information_wrapper">
        <section class="customer_information_wrapper--box">
          <div class="custom-legend">Standard Checkout</div>
          <div class="form__titleWrapper">
            <div col-12 [innerHTML]="getLabelCheckout('shippingLabelTC')"></div>
          </div>
          @if (this.isSelectedCB2) {
          <account-form-v2 class="account-form_wrapper" [braintreeDefaultZipPostalCode]="braintreeDefaultZipPostalCode"
            [braintreeDefaultCountry]="braintreeDefaultCountry" [euSpecified]="euSpecified" [guest]="guest"
            (countryChange)="onCountryChange($event)" [statesList]="statesList" [countriesList]="countriesList"
            [submittedAccountForm]="submittedAccountForm" [emailToConfirm]="emailToConfirm"
            (validateAddressAndCalculateTaxes)="validateAddressAndCalculateTaxes($event)"
            (rememberAccountInformation)="rememberAccountInformation()" (readyToCreateLead)="readyToCreateLead()"
            (emitConfirmEmail)="emailToConfirm=$event" (linkForm)="accountForm=$event">
          </account-form-v2>
          }

          <div [hidden]="isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder">
            <!-- SHIPPING INFORMATION -->
            @if (!this.isSelectedCB2) {
            <div justify-content-start class="form__row  shipping_form_row">
              <div col-12 class="shipping_form_col">
                <shipping-form-v2 [braintreeDefaultCountry]="braintreeDefaultCountry" [euSpecified]="euSpecified"
                  [couponValidation]="couponValidation" (shipToNameBinder)="shipToName=$event"
                  [submittedAccountForm]="submittedAccountForm"
                  [differentAddressStatesList]="differentAddressStatesList" (countryChange)="onCountryChange($event)"
                  [guest]="guest" [shipToName]="shipToName" [countriesList]="countriesList"
                  [shippingAddress]="shippingAddress"
                  (validateAddressAndCalculateTaxes)="validateAddressAndCalculateTaxes($event)"
                  (rememberAccountInformation)="rememberAccountInformation()"
                  (linkForm)="diffAddress=$event"></shipping-form-v2>
              </div>
            </div>
            }
          </div>


          <div
            [hidden]="isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder || braintreeTokenizePaymentData"
            class="form__row checkbox_row">
            <div col-12 class="checkbox_col" [ngClass]="braintreeHideShipping ? 'hidden' : ''">
              <input id="toggle_addres" type="checkbox"
                (click)="changeStateCB2(); rememberAccountInformation(); handleBraintreeDefaultSetup()"
                [(ngModel)]="this.isSelectedCB2" />
              <label for="toggle_addres">{{ getLabelCheckout('diffAddressTC')}}</label>
            </div>
          </div>
          @if (!this.isSelectedCB2) {
          <div class="form__titleWrapper form__titleWrapper--billing">
            <div col-12 [innerHTML]="getLabelCheckout('billinginformationTC')"></div>
          </div>
          <account-form-v2 class="account-form_wrapper" [braintreeDefaultZipPostalCode]="braintreeDefaultZipPostalCode"
            [braintreeDefaultCountry]="braintreeDefaultCountry" [euSpecified]="euSpecified" [guest]="guest"
            (countryChange)="onCountryChange($event)" [statesList]="statesList" [countriesList]="countriesList"
            [submittedAccountForm]="submittedAccountForm" [emailToConfirm]="emailToConfirm"
            (validateAddressAndCalculateTaxes)="validateAddressAndCalculateTaxes($event)"
            (rememberAccountInformation)="rememberAccountInformation()" (readyToCreateLead)="readyToCreateLead()"
            (emitConfirmEmail)="emailToConfirm=$event" (linkForm)="accountForm=$event">
          </account-form-v2>
          }

          <div [hidden]="isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder"
            class="checkbox_col checkbox_col--remember">
            <input data-qa="rem-info" class="remember-info-checkbox" type="checkbox" id="remember-pc"
              (click)="changeStatusIsRemembered()" tappable [checked]="isRememberInfoChecked" />
            <label for="remember-pc" id="remember-info"
              [innerHTML]="getLabelCheckout('remember') ? getLabelCheckout('remember') : 'Remember my Information'">Remember
              my Information</label>
          </div>
          <!-- <div class="comodo_wrapper">

            <!-- PAYMENT INFORMATION -->
          <section [hidden]="isBraintreeLoading || isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder"
            class="payment_information_wrapper">

            <!-- PAYMENT INFORMATION -->
            <div class="form__row " [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
              <div col-12 [innerHTML]="getLabelCheckout('paymentInformationTC')"></div>
            </div>

            <div class="secureText"><svg fill="#515862" height="20px" viewBox="0 -960 960 960" width="20px"
                xmlns="http://www.w3.org/2000/svg">
                <path _ngcontent-pbt-c2=""
                  d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z">
                </path>
              </svg>
              <p _ngcontent-pbt-c2="">Encrypted and Secured</p>
            </div>

            <div class="form__row  payment_row" [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
              <div col-12 class="payment_col">
                <div [hidden]="!braintreeClientToken || enableCyberSource" class="payment_tab_row row"
                  [ngClass]="braintreeHideShipping ? 'hidden' : ''">
                  <div class="payment_tab_col col braintree-payment-form" col-auto="">
                    {{getLabelCheckout('cc')}}&nbsp;&nbsp;<img alt="" src="assets/img/payment-card.png"></div>
                </div>
                <div [hidden]="!braintreeClientToken" class="braintree-card-row">
                  <div class="payment_form_col col" col-12="">
                    <div [hidden]="!braintreeClientToken" id="dropin-container"></div>
                    <div [hidden]="!braintreeClientToken" id="dropin-container-paypal" style="display:none;">
                      <div (click)="whatispaypal()" class="braintree-dropin braintree-loaded">
                        <div style="padding:10px;cursor:pointer;">Paying with PayPal</div>
                        <div data-braintree-id="methods-container" class="braintree-methods--active">
                          <div class="braintree-method braintree-method--active" tabindex="0" role="button">
                            <div class="braintree-method__icon-container braintree-method__delete-container">
                              <div class="braintree-method__icon braintree-method__delete">
                                <svg width="48" height="29">
                                  <use xlink:href="#iconX"></use>
                                </svg>
                              </div>
                            </div>

                            <div class="braintree-method__logo">
                              <svg width="40" height="24" class="">
                                <use xlink:href="#logoPayPal"></use>
                              </svg>
                            </div>

                            <div class="braintree-method__label">{{ braintreePayPalEmail }}<br>
                              <div class="braintree-method__label--small">PayPal</div>
                            </div>

                            <div class="braintree-method__icon-container braintree-method__check-container">
                              <div class="braintree-method__icon braintree-method__check">
                                <svg height="100%" width="100%">
                                  <use xlink:href="#iconCheck"></use>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-braintree-id="toggle" class="braintree-large-button braintree-toggle" tabindex="0"
                          role="button">
                          <span (click)="braintreeChooseAnotherWayToPay($event)">Remember my information and choose
                            another way
                            to
                            pay</span>
                        </div>
                      </div>
                    </div>
                    <a [hidden]="braintreeDropinValid || !braintreeDropInEnabled" class="item_link_bt_dr  braintreelink"
                      (click)="navigateToPageByGenericUrl('/what-is-this', 'name', 'width=500,height=330')"
                      href="/what-is-this">What is this?</a>

                  </div>
                </div>

                <div [hidden]="!braintreeClientToken || braintreeDropInEnabled || enableCyberSource"
                  id="dropin-container-hosted-fields" class="braintree-card-row form__row  payment_row">

                  <div class="payment_form_row formBT">
                    <div size="12" class="payment_form_col">
                      <form class="btpayment_form" id="paymentForm" novalidate>

                        <div class="form_item_wrapper btrow btfirstrow">
                          <label class="form_item_label" for="nameOnCardBT">{{ getLabelPayment('nameCard') }}</label>
                          <div class="form_item_elements btelements">
                            <div id="nameOnCardBT" class="inputBT"></div>
                            <div id="nameOnCardBTerror" class="hidden">
                              <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                            </div>
                          </div>
                        </div>

                        <div class="form_item_wrapper btrow">
                          <label class="form_item_label" for="typeOfCardBT">{{ getLabelPayment('cardType') }}</label>
                          <div class="form_item_elements  btelements">

                            <select class="item_select item_cartType" fixscrollonmobileios="" id="typeOfCardBT"
                              name="typeOfCard" required="">
                              <option value="visa">Visa</option>
                              <option value="mastercard">Mastercard</option>
                              <option value="amex">Amex</option>
                            </select>

                          </div>
                        </div>

                        <div class="form_item_wrapper btrow">
                          <label class="form_item_label" for="cardNumberBT">{{ getLabelPayment('cardNumber') }}</label>
                          <div class="form_item_elements btelements">
                            <div id="cardNumberBT" class="inputBT"></div>
                            <div id="cardNumberBTerror" class="hidden">
                              <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                            </div>
                          </div>
                        </div>

                        <div class="form_item_wrapper btrow">
                          <label class="form_item_label" for="expirationDateBT">{{ getLabelPayment('expirationDate')
                            }}</label>
                          <div class="form_item_elements btelements">
                            <div id="expirationDateBT" class="inputBT"></div>
                            <div id="expirationDateBTerror" class="hidden">
                              <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                            </div>
                            <span class="item_info_bt">{{ getLabelPayment('expirationDateLabelBT')}}</span>
                          </div>
                        </div>

                        <div class="form_item_wrapper btrow form_item_code btlastrow">
                          <label class="form_item_label" for="cvcCodeBT">{{ getLabelPayment('cvv') }}</label>
                          <div class="form_item_elements btelements">
                            <div id="cvcCodeBT" class="inputBT"></div>
                            <div id="cvcCodeBTerror" class="hidden">
                              <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                            </div>
                            <a class="item_link_bt"
                              (click)="navigateToPageByGenericUrl('/what-is-this', 'name', 'width=500,height=330')"
                              href="/what-is-this">{{ getLabelPayment('whatsThis') }}</a>
                          </div>

                        </div>
                      </form>

                    </div>
                  </div>
                </div>

                <payment-form-v2 [braintreeDefaultCountry]="braintreeDefaultCountry"
                  [hidden]="braintreeClientToken && !enableCyberSource" [cardName]="cardName" [cardType]="cardType"
                  (linkForm)="paymentForm=$event" [cardDetails]="cardDetails"
                  [submittedPaymentForm]="submittedPaymentForm" [monthArray]="monthArray"
                  [yearArray]="yearArray"></payment-form-v2>
              </div>
            </div>
          </section>
        </section>

        <!-- COMMENTS -->
        <div class="form__row  form_row_comments">
        </div>
        <div class="form__row  comment_row">


          @if (braintreeDefaultCountry == 'Germany') {
          <div class="content_col">
            <p>Indem Sie auf "Bestellung abschicken" klicken, erklären Sie sich mit den Allgemeinen
              <a (click)="navigateToPageByGenericUrl('https://legal.drmartypets.com/terms', 'name', 'width=400,height=400')"
                target="_blank"><u>Geschäftsbedingungen</u></a> und
              <a (click)="navigateToPageByGenericUrl('https://legal.drmartypets.com/privacy-policy', 'name', 'width=400,height=400')"
                target="_blank">
                <u>der Datenschutzrichtlinie</u></a> von Roundhouse Provisions einverstanden.
            </p>
            <p>*Dies ist ein geschätzter Umrechnungskurs, der Ihnen zur Verfügung gestellt wird. Ihr tatsächlicher
              Umrechnungskurs wird von Ihrer Bank festgelegt.</p>
          </div>
          }

          @if (braintreeDefaultCountry == 'Mexico') {
          <div class="content_col">
            <p>Al enviar su pedido a través del Sitio, acepta regirse y cumplir <a
                onclick="window.open(BRAND_BASE_URL + '/terminos-y-condiciones/', 'name','width=400,height=400')"
                style="display: inline" target="_blank"><u>los Términos y condiciones</u></a> e <a
                (click)="navigateToPageByGenericUrl('https://legal.drmartypets.com/privacy-policy', 'name', 'width=400,height=400')"><u>la Política
                  de
                  privacidad</u></a> de Roundhouse Provisions.
            </p>
          </div>
          }


          <div col-12 class="subscription_terms_wrapper content_col">
            <div class="showTerms">
              <p>By clicking Submit Order, you agree to our <a href="https://legal.drmartypets.com/terms" target="_blank">Terms
                  & Conditions</a>
                and <a href="https://legal.drmartypets.com/privacy-policy" target="_blank" class="footer__link">Privacy Policy</a>.
              </p>
              @if (isSubscription) {
              <div class="showTerms_subTerms">
                <p><b>Subscription Terms:</b> This is an automatically renewing subscription. By clicking Submit Order,
                  you also agree to our <a target="_blank" href="https://cdn.drmartypets.com/pages/subscription_terms_of_service.html">Subscription
                    Terms</a> and
                  authorize us to charge {{ ((isSubscription && !isPurchaseAvailable ? funnel.subscriptionPrice ?? 0 :
                  funnel.offerPrice ?? 0)) | dynamicCurrency:currency }} plus applicable taxes every {{
                  funnel.subscriptionFrequency | subscriptionTermsDaysFrequency }} to your selected payment method. Your
                  subscription renews every {{ funnel.subscriptionFrequency | subscriptionTermsDaysFrequency }} and
                  continues until canceled. You may cancel at any time via the <a target="_blank"
                    [href]="CART_BASE_URL + '/subscription-edit'">Subscription Page</a> in My Account or by
                  emailing <a target="_blank" href="mailto:support@drmartypets.com">support&#64;drmartypets.com</a>.
                </p>
              </div>
              }
            </div>
          </div>
          <div col-12 class="button_wrapper button_col">
            <!-- Non-Braintree SUBMIT ORDER button. So credit card fields uses Cybersource -->
            <!-- braintreeClient Token will be present on all braintree pages when BT is on paypal button or the credit card fields are BT -->
            <!-- enableCyberSource is new variable we are using when we are combining BT paypal and Cybersource for credit card field on our page -->
            <!-- braintreePayPalTokenizedPayment will be null on page load as we only get the token when there's a BT paypal payment. That's why we have protected it by pairing with braintreeClientToken-->
            <!-- We have used [hidden] instead of ngIf as we are switching the non-BT SUBMIT ORDER button with BT SUBMIT ORDER button below when we have a paypal BT transaction -->
            <button
              [hidden]="braintreeClientToken && !enableCyberSource || (braintreeClientToken && braintreePayPalTokenizedPayment)"
              id="order-form-submit-btn" type="submit"
              [disabled]="(!buttonList[0].isPlaceOrder && isConsentStatus) || (!termsAgreed && submitOrderCheckBox) || isBraintreeLoading"
              (click)="isPayPalBillingAgreementApproved ?
                submitPayPalOrder(accountForm) :
                buttonList[0].isPlaceOrder ?
                onPayWithDifferentAddressClicked(accountForm, paymentForm, diffAddress) :
                submitAmazonPay(accountForm)"
              [innerHTML]="getLabelCheckout('submitorder') ? getLabelCheckout('submitorder') : 'Submit Order'">Submit
              Order
            </button>

            <!-- Straight up Braintree SUBMIT ORDER button -->
            <button [hidden]="!braintreeClientToken || (enableCyberSource && !braintreePayPalTokenizedPayment)"
              id="order-form-submit-btn" type="submit"
              [disabled]="(!buttonList[0].isPlaceOrder && isConsentStatus) || (!termsAgreed && submitOrderCheckBox) || isBraintreeLoading"
              (click)="payWithBrainTree(accountForm, diffAddress)"
              [innerHTML]="getLabelCheckout('submitorder') ? getLabelCheckout('submitorder') : 'Submit Order'">Submit
              Order
            </button>
          </div>

          @if (showFeatures) {
          <div class="features features--mobile">
            <div class="mbgArea feature"><img [src]="CDN_IMAGES.CHECKOUT_90DAY" alt="Money Back Guarantee icon"
                class="mbg w-8" loading="lazy" decoding="async">
              <p>90 Day Money Back Guarantee</p>
            </div>
            @if (unitsSold > 0) {
            <div class="unitSoldArea feature"><img [src]="CDN_IMAGES.TROPHY" alt="Trophy icon" class="unitFlag w-8"
                loading="lazy" decoding="async">
              <p>Over {{ unitsSold | unitsSoldFormat }} units sold</p>
            </div>
            }
            @if ((isFreeChecked && (+shippingRateIndex === 0) ? 0 :
            ((shippingCost ? +shippingCost: 0) + (calculatedShippingCost ? +calculatedShippingCost : 0)
            )) == 0) {
            <div class="truck feature"><img [src]="CDN_IMAGES.CHECKOUT_TRUCK" alt="Truck icon" class="truck"
                loading="lazy" decoding="async">
              <p>Fast and Free Shipping</p>
            </div>
            }
          </div>
          }
        </div>
      </article>

      <!-- ORDER DETAILS -->
      <article class="order_details_wrapper">
        <section class="form__row  billing_form_row">
          <div col-12 col-md-12 no-padding class="total_col">

            <div [hidden]="isBraintreeLoading" class="price_button" col-lg-12 col-12>
              <!-- NON-showProductBoxVariant1 ORDER DETAILS INTERNATIONAL (DYNAMIC CURRENCY) -->
              @if (!showProductBoxVariant1) {
              <div class="table_coupon_wrapper" col-lg-6>
                <div class="table_wrapper" style="flex-direction: column;">
                  <!-- Default -->
                  <table [ngClass]="braintreeEnabled ? 'tablepadding' : ''">
                    @if (!hideRegularPrice) {
                    <tr>
                      <td>{{ getLabelCheckout('Regular Price') }}:</td>
                      <td class="table_regularPrice">{{ (funnel && funnel.standardPrice ? funnel.standardPrice : (funnel
                        &&
                        funnel.offerPrice ? funnel.offerPrice : 1)) | dynamicCurrency:currency }}</td>
                    </tr>
                    }
                    @if (!hideSavings) {
                    <tr class="table_savings">
                      <td>{{ getLabelCheckout('Savings') }}:</td>
                      <td>-{{ ((funnel && funnel.standardPrice && funnel.offerPrice ? (funnel.standardPrice -
                        funnel.offerPrice) : 1)) | dynamicCurrency:currency }}</td>
                    </tr>
                    }
                    @if (showSubtotal) {
                    <tr class="table_regularPrice">
                      <td [innerHTML]="getLabelCheckout('showsub') ? getLabelCheckout('showsub') : 'Subtotal:'">{{
                        getLabelCheckout('showSubtotal') }}:</td>
                      <td>{{ ((funnel && funnel.offerPrice && funnel.offerPrice ? funnel.offerPrice : 1)) |
                        dynamicCurrency:currency }}</td>
                    </tr>
                    }
                    @if (!priceWithTax && funnelOffersData[0]) {
                    <tr class="table_tax">
                      <td>{{ getLabelCheckout('Sales Tax') }} <span class="tooltip">&nbsp;&#9432; <span
                            class="tooltiptext">Tax estimated for a shipping address in the {{ braintreeDefaultCountry
                            }}.</span></span>:</td>
                      @if (braintreeClientToken) {
                      <td>{{ (totalTax) | dynamicCurrency:currency }} </td>
                      }
                      @if (!braintreeClientToken) {
                      <td>{{ ((!funnelOffersData[0].isPurchaseAvailable &&
                        funnelOffersData[0].isSubscriptionAvailable &&
                        !isPayPalSubscription) ? subscriptionTax : (!funnelOffersData[0].isFreeFirstShipping ? totalTax
                        :
                        (isPayPalSubscription ? totalTax : subscriptionTax))) | dynamicCurrency:currency }}</td>
                      }
                    </tr>
                    }
                    <tr>
                      <td>{{ getLabelCheckout('Shipping') }}:</td>
                      <td>{{ ((funnel.isFreeFirstShipping && selectedDeliveryDay == 'Free' ) ? 0 : ((1 * shippingCost) +
                        (1
                        *
                        calculatedShippingCost))) | dynamicCurrency:currency }}</td>
                    </tr>
                    @if (coupon.discountAmount) {
                    <tr>
                      <td>{{ getLabelCheckout('Coupon discount') }}:</td>
                      <td>{{ (couponDiscount) | dynamicCurrency:currency }}</td>
                    </tr>
                    }
                    @if (getBraintreeTaxEstimate() == 0) {
                    <tr class="total">
                      <td>{{ getLabelCheckout('Total') }}@if (currency !== 'USD') {
                        <span> (w/ {{
                          getLabelCheckout('Sales
                          Tax') }})</span>
                        }:
                      </td>
                      @if (priceWithTax) {
                      <td>{{ (funnel && funnel.offerPrice || 1) + ((funnel.isFreeFirstShipping &&
                        selectedDeliveryDay === 'Free') ? 0 : shippingCost) + couponDiscount | dynamicCurrency:currency
                        }}
                        {{ currency !== 'USD' ? currency : '' }}</td>
                      }
                      @if (!priceWithTax) {
                      <td>{{ (funnel && funnel.offerPrice || 1) + ((funnel.isFreeFirstShipping &&
                        selectedDeliveryDay === 'Free') ? 0 : shippingCost) + couponDiscount + totalTax |
                        dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</td>
                      }
                      <!-- <td *ngIf="coupon.discountType !== 'Free Shipping' && totalPrice > 0">{{ (totalPrice) |
                    dynamicCurrency:currency  }} {{ currency !== 'USD' ? currency : '' }}</td> -->
                    </tr>
                    }
                  </table>
                </div>
                <!-- Coupon -->
                @if (!isPayPalBillingAgreementApproved) {
                <div class="coupon_wrapper">
                  <label for="order-form-coupon-input">{{ getLabelCheckout('couponMessage')}} <i>{{
                      getLabelCheckout('optional')}}</i>:</label>
                  <div class="elements_wrapper">
                    <input id="order-form-coupon-input" [(ngModel)]="couponCode" type="text" fixScrollOnMobileiOS
                      (change)="sanitizeCouponCode()" data-qa="coupon-field" />
                    <button data-qa="coupon-apply" (click)="getCoupon()">{{getLabelCheckout('Apply')}}</button>
                  </div>
                </div>
                }
              </div>
              }

              <!-- PRODUCT SUMMARY BOX NON-INTERNATIONAL -->
              @if (showProductBoxVariant1) {
              <div class="table_coupon_wrapper-v2 productBoxV2">
                <div class="productBoxV2__orderSummary">
                  <h3 class="productBoxV2__orderSummary--title hidden-mobile">Order Summary</h3>
                  <div class="productBoxV2__orderBox">
                    <img class="productBoxV2__productImg" src={{productImage}} alt="Product Image" loading="eager"
                      fetchpriority="high" decoding="sync">
                    <p class="productBoxV2__description">{{currentFunnel.product?.description}} <br> {{isSubscription ?
                      '' : 'One time purchase'}}</p>
                    <p class="productBoxV2__orderPrice">
                      <s>{{ (funnel && funnel.standardPrice ? funnel.standardPrice : 0) | dynamicCurrency:currency
                        }}</s>
                      <br />
                      @if (isSubscription && !isPurchaseAvailable) {
                      <span>{{ (currentFunnel.subscriptionPrice || 0) |
                        dynamicCurrency:currency }}</span>
                      }
                      @if (!isSubscription || isPurchaseAvailable) {
                      <span>{{ (currentFunnel.offerPrice || 0) |
                        dynamicCurrency:currency }}</span>
                      }
                    </p>
                  </div>
                  <hr>
                  <div class="productBoxV2__lineItem">
                    <p>Subtotal</p>
                    @if (isSubscription && !isPurchaseAvailable) {
                    <p>{{ (currentFunnel.subscriptionPrice || 0) |
                      dynamicCurrency:currency }}</p>
                    }
                    @if (!isSubscription || isPurchaseAvailable) {
                    <p>{{ (currentFunnel.offerPrice || 0) |
                      dynamicCurrency:currency }}</p>
                    }
                  </div>
                  <div class="productBoxV2__lineItem">
                    <p>Sales Tax</p>
                    <p>{{ ((isSubscription && !isPurchaseAvailable && !isFreeChecked) ? subscriptionTax : totalTax) |
                      dynamicCurrency:currency }}</p>
                  </div>
                  <div class="productBoxV2__lineItem">
                    <p>Shipping</p>
                    <p class="productBoxV2__lineItem--shipping">
                      @if ((isFreeChecked && (+shippingRateIndex === 0) ? 0 : ((shippingCost ? +shippingCost: 0) +
                      (calculatedShippingCost ? +calculatedShippingCost : 0))) !== 0) {
                      {{ (isFreeChecked && (+shippingRateIndex === 0) ? 0 : ((shippingCost ? +shippingCost: 0) +
                      (calculatedShippingCost ? +calculatedShippingCost : 0))) | dynamicCurrency:currency }}
                      }
                      @if ((isFreeChecked && (+shippingRateIndex === 0) ? 0 : ((shippingCost ? +shippingCost: 0) +
                      (calculatedShippingCost ? +calculatedShippingCost : 0))) == 0) {
                      FREE
                      }
                    </p>
                  </div>
                  @if (coupon.discountAmount) {
                  <div class="productBoxV2__lineItem highlighted">
                    <p><b>Coupon discount:</b></p>
                    <p class="linePrice">
                      <b>{{ couponDiscount | currency:'USD':'symbol-narrow':'.2-2' }}</b>
                    </p>
                  </div>
                  }
                  <hr>
                  <div class="productBoxV2__totalLine">
                    <b>
                      <p>Total</p>
                    </b>
                    <b>
                      <p class="productBoxV2__totalNumber">{{ ((totalPrice !== null && totalPrice !== undefined &&
                        totalPrice > 0) ? (+totalPrice + +transactionFeeAmount) : (funnel && funnel.offerPrice &&
                        funnel.offerPrice ? funnel.offerPrice + productTax + shippingCost + shippingTax : 1))
                        |dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</p>
                    </b>
                  </div>
                </div>
                @if (showFeatures) {
                <div class="features features--desktop">
                  <div class="mbgArea feature"><img [src]="CDN_IMAGES.CHECKOUT_90DAY" alt="Money Back Guarantee icon"
                      class="mbg w-8" loading="lazy" decoding="async">
                    <p>90 Day Money Back Guarantee</p>
                  </div>
                  @if (unitsSold > 0) {
                  <div class="unitSoldArea feature"><img [src]="CDN_IMAGES.TROPHY" alt="Trophy icon"
                      class="unitFlag w-8" loading="lazy" decoding="async">
                    <p>Over {{ unitsSold | unitsSoldFormat }} units sold</p>
                  </div>
                  }
                  @if ((isFreeChecked && (+shippingRateIndex === 0) ? 0 :
                  ((shippingCost ? +shippingCost: 0) + (calculatedShippingCost ? +calculatedShippingCost : 0)
                  )) == 0) {
                  <div class="truck feature"><img [src]="CDN_IMAGES.CHECKOUT_TRUCK" alt="Truck icon"
                      class="truck w-8 h-auto" loading="lazy" decoding="async">
                    <p>Fast and Free Shipping</p>
                  </div>
                  }
                </div>
                }
                <!--COUPON TABLE-->
                @if (showCoupon) {
                <div class="flex flex-col items-end justify-end text-right gap-2">
                  <div class="table_coupon_wrapper">
                    <div class="coupon_wrapper" [hidden]="isPayPalBillingAgreementApproved">
                      <label for="order-form-coupon-input">Coupon code <i>(optional)</i>:</label>
                      <div class="elements_wrapper">
                        <input id="order-form-coupon-input" [(ngModel)]="couponCode" type="text" fixScrollOnMobileiOS
                          (change)="sanitizeCouponCode()" />
                        <button (click)="getCoupon()">Apply</button>
                      </div>
                    </div>
                  </div>
                  @if (couponDiscount && !isPayPalBillingAgreementApproved) {
                  <div class="coupon_content">
                    <p><b>COUPON ACTIVATED!</b></p>
                  </div>
                  }
                </div>
                }
              </div>
              }

              <!-- NON-showProductBoxVariant1 BUTTONS -->
              @if (!showProductBoxVariant1) {
              <div class="buttons_wrapper" [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
                @if (!isPayPalBillingAgreementApproved && (!isSubscription || !isPurchaseAvailable)) {
                <button name="PayPal" id="order-form-paypal-button" [hidden]="!showPayPalPayButton"
                  class="paypal_button" alt="PayPal" type="submit"
                  (click)="checkoutPayPalWithDifferentAddress(accountForm, diffAddress)">@if (showPayPalPayButton) {
                  <img src="{{ iconPaypal }}" alt="PayPal" loading="eager" fetchpriority="high" decoding="sync" />
                  }</button>
                }
                <div [hidden]="isPayPalBillingAgreementApproved || !showAmazonButton" id="AmazonPayButton"
                  class="amazonpay_button"></div>
                <div [hidden]="braintreeHidePayPalButton || isBraintreeLoading || !braintreeEnabled" id="paypal-button">
                </div>
              </div>
              }
            </div>

            <div [hidden]="!braintreeClientToken || paypalButtonLoaded()" class="loader"></div>

          </div>

        </section>
      </article>
    </div>
  </section>
</div>